var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoteyesCheck = function SvgShoteyesCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shoteyesCheck_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shoteyesCheck_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 5 4 4M21 5l-4 4M22 15l-3.5 4-2-2M13 5H2v4h11zM13 15H2v4h11z",
    className: "shoteyesCheck_svg__st0"
  })));
};
export default SvgShoteyesCheck;